import AccordeonComponent from "../../../../../components/accordeon/AccordeonComponent";
import { useState, useEffect } from "react";
import { List } from "./list";
import { ItemList } from "./itemList";
import { CHARACTERISTICS_EXTRA, SECURITY_EXTRA, ACCESSORIES_EXTRA, withContent } from "./extraItems";
import { Alert } from "../../../../../assets/alert";
import { Arrow } from "../../../../../assets/arrow";
import { Link } from "react-router-dom";
import { getWarrantyBadge, hasWarrantyPlan } from "../../../../../../utils/warrantyPlan";
import { routes } from "../../../../../routes/RoutesComponent";
import ReactMarkdown from "react-markdown";
import GetColserAutoByPlacaApiImpl from "../../../../../../../data/repositories/colserauto/GetColserAutoByPlacaApiImpl";

const fmt = (n: number) =>
    new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(n);

export const FeatureList = ({ car, description }) => {
    const [claimsInfo, setClaimsInfo] = useState(false);
    const [warrantyInfo, setWarrantyInfo] = useState(false);
    const [showReportColserauto, setShowReportColserauto] = useState(false);
    const [showWhatClaim, setShowWhatClaim] = useState(false);
    const [colserData, setColserData] = useState<any | null>(null);
    const [colserLoading, setColserLoading] = useState(false);
    const traction = [
        { id: 0, text: "Trasera" },
        { id: 1, text: "4 x 4" },
        { id: 2, text: "Delantera" },
        { id: 3, text: "4 x 2" },
    ];

    const warrantyBadge = getWarrantyBadge(car);
    const warrantyMessage = () => warrantyBadge.label;
    const hasWarranry = hasWarrantyPlan(car);
    const isSixMonths = warrantyBadge.variant === "sixMonths";

    useEffect(() => {
        if (!showReportColserauto || colserData || colserLoading) return;
        setColserLoading(true);
        GetColserAutoByPlacaApiImpl(car.plate).then((res) => {
            setColserData(res ?? null);
            setColserLoading(false);
        });
    }, [showReportColserauto]);

    const motorcycleType = description?.find((item) => item?.item === 46)?.content;

    const characteristics = [
        {
            icon: "/assets/icons/featureList/6.png",
            title: "Cilindraje",
            content: description?.find((item) => item?.item === 43)?.content ?? car.motor,
        },
        {
            icon: "/assets/icons/featureList/7.png",
            title: "Tipo de combustible",
            content: description?.find((item) => item?.item === 44)?.content ?? car.typeOfFuel.name,
        },
        {
            icon: "/assets/icons/featureList/8.png",
            title: "Tipo de caja",
            content: description?.find((item) => item?.item === 45)?.content ?? car.transmission,
        },
        {
            icon: "/assets/icons/featureList/motorcycle.svg",
            title: "Tipo de motocicleta",
            content: motorcycleType,
        },
        {
            icon: "/assets/icons/featureList/9.png",
            title: "Tipo de vehículo",
            content: motorcycleType ? null : car.type.name,
        },
        {
            icon: "/assets/icons/featureList/11.png",
            title: "Chasis de motocicleta",
            content: description?.find((item) => item?.item === 47)?.content,
        },
        {
            icon: "/assets/icons/featureList/10.png",
            title: "Número de puestos",
            content: motorcycleType ? null : description?.find((item) => item?.item === 8)?.content,
        },
        {
            icon: "/assets/icons/featureList/12.png",
            title: "Turbo",
            content: description?.find((item) => item?.item === 7)?.content,
        },
        {
            icon: "/assets/icons/featureList/11.png",
            title: "Tracción",
            content:
                description?.find((item) => item?.item === 57)?.content ??
                (motorcycleType ? null : traction?.find((item) => item?.id === car.traction)?.text),
        },
        ...withContent(description, CHARACTERISTICS_EXTRA),
    ].filter((characteristic) => characteristic.content);

    const halfCharacteristics = Math.ceil(characteristics.length / 2);

    return (
        <div className="w-100">
            <AccordeonComponent
                options={[
                    {
                        title: hasWarranry ? warrantyMessage() : "Garantía",
                        // showOption: car.warranty,
                        content: (
                            <div className="d-flex flex-column flex-md-row">
                                <List>
                                    {!hasWarranry && (
                                        <ItemList
                                            onClick={() => setWarrantyInfo(!warrantyInfo)}
                                            icon={"/assets/icons/featureList/2.png"}
                                            title={"Garantía"}
                                            content={
                                                <>
                                                    <div className="position-relative">
                                                        <div
                                                            style={{
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                marginTop: "0",
                                                            }}
                                                        >
                                                            <Alert />

                                                            <strong
                                                                style={{ margin: "0 2px 0 0", height: "18px" }}
                                                                className="ms-2"
                                                            >
                                                                {hasWarranry ? "SÍ" : "NO"}
                                                            </strong>
                                                            <div
                                                                className="ms-2"
                                                                style={{
                                                                    transform: warrantyInfo
                                                                        ? "rotate(0deg)"
                                                                        : "rotate(180deg)",
                                                                }}
                                                            >
                                                                <Arrow />
                                                            </div>
                                                        </div>
                                                        <span
                                                            className="warranty_tool_tip_detail position-absolute"
                                                            style={{ display: warrantyInfo ? "block" : "none" }}
                                                        >
                                                            {car.warranty
                                                                ? "Te ofrecemos una garantía de 1 año o 4.000 km por defectos de fabricación en más de 3,000 componentes del auto.  No cubrimos piezas de desgaste ni daños ocasionados por mal manejo o falta de mantenimiento. Para conocer el detalle ponte en contacto con un consejero."
                                                                : "La garantía aplica para autos con menos de 13 años de antigüedad, que tengan menos de 130.000 kilómetros y que en la publicación se diga explícitamente que cuentan con garantía. Para mayor información contáctese con un consultor."}
                                                        </span>
                                                    </div>
                                                </>
                                            }
                                        />
                                    )}

                                    {hasWarranry && (
                                        // {car.warranty_type && ( // TODO: Deuda tecnica: revisar validación
                                        <li className="mb-3 mb-md-4 d-flex align-items-center">
                                            <img
                                                style={{ width: "44px", height: "44px" }}
                                                src={"/assets/icons/warranty.svg"}
                                                className="img-fluid me-2"
                                            />
                                            <span className="d-block">
                                                <p style={{ fontWeight: 700, color: "#1E1E1E", fontSize: 16 }}>
                                                    {warrantyMessage()}
                                                </p>
                                                <Link
                                                    style={{
                                                        color: "#FF4800",
                                                        fontWeight: 700,
                                                        marginBottom: 5,
                                                        marginTop: 5,
                                                        display: "block",
                                                    }}
                                                    target="_blank"
                                                    to={"/Términosycondiciones-garantia-vehículos-usados/65"}
                                                >
                                                    Términos y condiciones acá.
                                                </Link>
                                                <strong className="" style={{ fontWeight: 500 }}>
                                                    {isSixMonths
                                                        ? "La garantía aplica para autos con menos de 13 años de antigüedad, que tengan menos de 130.000 kilómetros."
                                                        : "La garantía de fabrica es la garantía que proporciona la marca sobre ese vehículo, durante un periodo limitado de tiempo o hasta un kilometraje específico (lo que ocurra primero)."}
                                                </strong>
                                                {warrantyBadge.variant === "factory" &&
                                                    car.factory_warranty_coverage && (
                                                        <p style={{ marginTop: 8, fontSize: 14, color: "#666C89" }}>
                                                            <strong style={{ color: "#1E1E1E" }}>Válida hasta: </strong>
                                                            {car.factory_warranty_coverage}
                                                        </p>
                                                    )}
                                            </span>
                                        </li>
                                    )}
                                </List>
                                <List>
                                    {hasWarranry && isSixMonths && (
                                        <li className="mb-3 mb-md-4 d-flex align-items-center">
                                            <img
                                                style={{ width: "44px", height: "44px" }}
                                                src={"/assets/icons/warranty.svg"}
                                                className="img-fluid me-2"
                                            />
                                            <span className="d-block">
                                                <p style={{ fontWeight: 700, color: "#1E1E1E", fontSize: 16 }}>
                                                    Garantía de felicidad
                                                </p>
                                                <Link
                                                    style={{
                                                        color: "#FF4800",
                                                        fontWeight: 700,
                                                        marginBottom: 5,
                                                        marginTop: 5,
                                                        display: "block",
                                                    }}
                                                    target="_blank"
                                                    to={"/7-dias-o-te-cambiamos-el-carro/31"}
                                                >
                                                    Términos y condiciones acá.
                                                </Link>
                                                <strong className="" style={{ fontWeight: 500 }}>
                                                    Lleva tu vehículo y si no estas satisfecho puedes cambiarlo, tienes
                                                    hasta 7 días o 300 km para hacerlo.
                                                </strong>
                                            </span>
                                        </li>
                                    )}

                                    {description?.find((item) => item?.item === 40)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/2.png"}
                                            title={"Garantía de fábrica"}
                                            content={description?.find((item) => item?.item === 40)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 41)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/2.png"}
                                            title={"Garantía de kilometraje"}
                                            content={description?.find((item) => item?.item === 41)?.content}
                                        />
                                    )}
                                </List>
                            </div>
                        ),
                    },
                    {
                        title: "Historial, documentación y llaves",
                        content: (
                            <div
                                className="d-flex flex-column flex-md-row"
                                onClick={() => claimsInfo && setClaimsInfo(false)}
                            >
                                <List>
                                    {description?.find((item) => item?.item === 42)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/car-key.png"}
                                            title={"Número de llaves"}
                                            content={description?.find((item) => item?.item === 42)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 4)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/5.png"}
                                            title={"Fecha de vencimiento SOAT"}
                                            content={description?.find((item) => item?.item === 4)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 5)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/5.png"}
                                            title={"Fecha de vencimiento revisión tecnicomecánica"}
                                            content={description?.find((item) => item?.item === 5)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 3)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/5.png"}
                                            title={"Ciudad de matrícula"}
                                            content={description?.find((item) => item?.item === 3)?.content}
                                        />
                                    )}
                                </List>
                                <List>
                                    <ItemList
                                        icon={"/assets/icons/featureList/5.png"}
                                        title={"Placa"}
                                        content={car.plate.slice(-1)}
                                    />

                                    {description?.find((item) => item?.item === 1)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/5.png"}
                                            title={"Número de propietarios anteriores"}
                                            content={description?.find((item) => item?.item === 1)?.content}
                                        />
                                    )}
                                </List>
                            </div>
                        ),
                    },
                    {
                        title: "Reclamaciones de aseguradora",
                        content: (
                            <>
                                <div className="d-flex flex-column flex-md-row ">
                                    <div className="d-inline-block m-0 list-unstyled col-12">
                                        <div className={" w-full"}>
                                            <li
                                                onClick={() => setWarrantyInfo(!warrantyInfo)}
                                                className={`d-flex align-items-center ${
                                                    !warrantyInfo ? "mb-2" : "mb-1"
                                                }`}
                                            >
                                                <img
                                                    style={{ width: "32px", height: "32px" }}
                                                    src={"/assets/icons/featureList/3.png"}
                                                    className="img-fluid me-2"
                                                />
                                                <span className="d-block">
                                                    <p
                                                        style={{
                                                            marginBottom: 5,
                                                            marginTop: 5,
                                                            display: "block",
                                                        }}
                                                    >
                                                        Reclamaciones reportadas y tipo
                                                    </p>
                                                    <div className="position-relative">
                                                        <div
                                                            className="d-flex align-items-top"
                                                            onClick={() => setClaimsInfo(!claimsInfo)}
                                                        >
                                                            <Alert height={18} width={18} />
                                                            <p
                                                                className="d-flex align-items-center mx-1 "
                                                                style={{ fontWeight: 700 }}
                                                            >
                                                                {description?.find((item) => item?.item === 2)
                                                                    ?.content ?? "NO"}
                                                            </p>
                                                            <div
                                                                className="ms-2"
                                                                style={{
                                                                    transform: warrantyInfo
                                                                        ? "rotate(0deg)"
                                                                        : "rotate(180deg)",
                                                                }}
                                                            >
                                                                <Arrow />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </span>
                                            </li>
                                            <span
                                                className="w-full mb-3"
                                                style={{
                                                    display: warrantyInfo ? "block" : "none",
                                                }}
                                            >
                                                <div className="mt-3">
                                                    <p style={{ fontWeight: "normal", fontSize: "16px" }}>
                                                        <strong>Historial de reclamaciones y accidentes: </strong>En
                                                        Colombia, las fuentes de información sobre el historial de
                                                        reclamaciones o accidentes de un vehículo no se encuentran
                                                        unificadas ni centralizadas.
                                                        <br />
                                                        En coherencia con nuestro compromiso de transparencia,{" "}
                                                        <strong>WCAR</strong> pone a disposición del consumidor el
                                                        historial de reclamaciones emitido por entidades autorizadas,
                                                        como <strong>Colserauto</strong>, exclusivamente con fines
                                                        informativos, para brindar una referencia adicional al momento
                                                        de tomar una decisión de compra.
                                                        <br />
                                                        <br />
                                                        <strong>Alcance del informe:</strong> Este informe no constituye
                                                        una certificación definitiva ni una garantía sobre la
                                                        inexistencia de reclamaciones, accidentes o eventos anteriores,
                                                        y su contenido depende íntegramente de la información reportada,
                                                        actualizada o eventualmente eliminada por las aseguradoras u
                                                        otras fuentes, aspectos ajenos al control de{" "}
                                                        <strong>WCAR</strong>.
                                                        <br />
                                                        <br />
                                                        <strong>Limitación de responsabilidad:</strong> En consecuencia,
                                                        si la información aquí presentada llegare a diferir de la
                                                        realidad, ello no genera responsabilidad para{" "}
                                                        <strong>WCAR</strong>.
                                                        <br />
                                                        <br />
                                                        <strong>Recomendación al consumidor:</strong> Recomendamos al
                                                        consumidor complementar este insumo con las revisiones
                                                        mecánicas, peritajes, consultas ante autoridades competentes y
                                                        demás verificaciones que considere pertinentes.
                                                    </p>
                                                </div>
                                            </span>
                                            <div className="mb-2">
                                                <div
                                                    className="d-flex d-flex align-items-center"
                                                    onClick={() => {
                                                        setShowReportColserauto(!showReportColserauto);
                                                        setShowWhatClaim(false);
                                                    }}
                                                >
                                                    <img
                                                        src="/assets/icons/featureList/report-claim.png"
                                                        width={32}
                                                        height={32}
                                                        className="img-fluid me-2"
                                                        alt=""
                                                    />
                                                    <p>Reporte de </p>
                                                    <img
                                                        src="/assets/icons/featureList/colserauto-pdf.png"
                                                        width={120}
                                                        height={120}
                                                        className="img-fluid ms-1"
                                                        alt="ColserAuto"
                                                        style={{ paddingTop: 0 }}
                                                    />
                                                    <div
                                                        className="ms-2"
                                                        style={{
                                                            transform: showReportColserauto
                                                                ? "rotate(0deg)"
                                                                : "rotate(180deg)",
                                                        }}
                                                    >
                                                        <Arrow />
                                                    </div>
                                                </div>
                                                {showReportColserauto && (
                                                    <div className="colser-report-card mt-3">
                                                        <div className="colser-report-header">
                                                            <div className="colser-report-title-block">
                                                                <div className="colser-report-title-row">
                                                                    <div className="colser-report-title-bar" />
                                                                    <h3 className="colser-report-title">
                                                                        Reporte de{" "}
                                                                        <span className="colser-report-title-accent">
                                                                            reclamaciones
                                                                        </span>
                                                                    </h3>
                                                                </div>
                                                                {colserData?.siniestros && (
                                                                    <p className="colser-report-date">
                                                                        Fecha: {colserData.fecha_inspeccion ?? "—"}
                                                                    </p>
                                                                )}
                                                            </div>
                                                            <img
                                                                src="/assets/icons/featureList/colserauto-pdf.png"
                                                                alt="ColserAuto"
                                                                className="colser-report-logo"
                                                            />
                                                        </div>

                                                        {colserLoading && (
                                                            <div className="colser-report-loading">
                                                                <div className="colser-spinner" />
                                                                <span>Consultando reporte…</span>
                                                            </div>
                                                        )}

                                                        {!colserLoading && !colserData && (
                                                            <p className="colser-report-empty">
                                                                No se encontró información de reclamaciones para esta
                                                                placa.
                                                            </p>
                                                        )}

                                                        {!colserLoading && colserData && (
                                                            <>
                                                                <div className="colser-table-wrap">
                                                                    <table className="colser-table">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Placa</th>
                                                                                <th>Tipo de reclamación</th>
                                                                                <th>Fecha</th>
                                                                                <th>Valor reclamado</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {colserData.siniestros?.detalle?.length >
                                                                            0 ? (
                                                                                colserData.siniestros.detalle.map(
                                                                                    (s: any, i: number) => (
                                                                                        <tr key={i}>
                                                                                            {i === 0 && (
                                                                                                <td
                                                                                                    className="colser-placa-cell"
                                                                                                    rowSpan={
                                                                                                        colserData
                                                                                                            .siniestros
                                                                                                            .detalle
                                                                                                            .length
                                                                                                    }
                                                                                                >
                                                                                                    <strong>
                                                                                                        {String(
                                                                                                            colserData
                                                                                                                .vehiculo
                                                                                                                ?.placa ??
                                                                                                                car.plate ??
                                                                                                                "",
                                                                                                        ).slice(-1)}
                                                                                                    </strong>
                                                                                                </td>
                                                                                            )}
                                                                                            <td>
                                                                                                {s.tipo_reclamacion}
                                                                                            </td>
                                                                                            <td>{s.fecha}</td>
                                                                                            <td>{fmt(s.valor)}</td>
                                                                                        </tr>
                                                                                    ),
                                                                                )
                                                                            ) : (
                                                                                <tr>
                                                                                    <td
                                                                                        className="colser-placa-cell"
                                                                                        style={{ fontWeight: 700 }}
                                                                                    >
                                                                                        {String(
                                                                                            colserData.vehiculo
                                                                                                ?.placa ??
                                                                                                car.plate ??
                                                                                                "",
                                                                                        ).slice(-1)}
                                                                                    </td>
                                                                                    <td
                                                                                        colSpan={3}
                                                                                        className="colser-no-claims"
                                                                                    >
                                                                                        Sin reclamaciones registradas
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <p className="colser-report-disclaimer">
                                                                    Se advierte que en ningún caso esta información
                                                                    deberá considerarse como exhaustiva, completa o que
                                                                    de cualquier forma satisfaga todas las necesidades
                                                                    del usuario. COLSERAUTO S.A. no se hace responsable
                                                                    por errores, inexactitud o interpretaciones erradas
                                                                    de la información emitida. La consulta realizada
                                                                    solo corresponde a las reclamaciones reportadas al
                                                                    vehículo contado por PLACA, no incluye daños o
                                                                    lesiones a terceros.
                                                                </p>
                                                            </>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="mb-2">
                                                {description?.find((item) => item?.item === 6)?.content && (
                                                    <ItemList
                                                        icon={"/assets/icons/featureList/amount-claim.png"}
                                                        title={"Monto de reclamaciones"}
                                                        content={description?.find((item) => item?.item === 6)?.content}
                                                    />
                                                )}
                                            </div>
                                            <div
                                                className="d-flex d-flex align-items-center"
                                                onClick={() => {
                                                    setShowWhatClaim(!showWhatClaim);
                                                    setShowReportColserauto(false);
                                                }}
                                            >
                                                <img
                                                    src="/assets/icons/featureList/question-claim.png"
                                                    width={32}
                                                    height={32}
                                                    className="img-fluid me-2"
                                                    alt=""
                                                />
                                                <p>¿Qué es una reclamación?</p>
                                                <div
                                                    className="ms-2"
                                                    style={{
                                                        transform: showWhatClaim ? "rotate(0deg)" : "rotate(180deg)",
                                                    }}
                                                >
                                                    <Arrow />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div>
                                    <p style={{ fontWeight: "normal", fontSize: "16px" }}>
                                        <strong>Reclamaciones: </strong>En nuestro compromiso con la transparencia,
                                        proporcionamos detalles sobre las reclamaciones o accidentes reportados por las
                                        aseguradoras.
                                        <br />
                                        <br />
                                        <strong>
                                            ¿Qué es una reclamación de menor cuantía o pérdida parcial?:
                                        </strong>{" "}
                                        Una reclamación de menor cuantía ocurre cuando el costo de reparar o reemplazar
                                        partes del vehículo no excede el 75% del valor asegurado.
                                        <br />
                                        <br />
                                        <strong>¿Qué es una pérdida total?: </strong> Una pérdida total se produce
                                        cuando las reparaciones de los daños de un vehículo superan el 75% de su valor
                                        asegurable.
                                        <br />
                                        <br />
                                        <strong>¿Qué es un auto recuperado?: </strong> Un auto recuperado es aquel que
                                        previamente estaba asegurado, fue robado y el propietario recibió una
                                        indemnización por parte de la aseguradora. Sin embargo, posteriormente el
                                        vehículo fue recuperado por la aseguradora, lo que resulta en un reporte de
                                        recuperación asociado al automóvil. Este evento puede afectar el valor comercial
                                        del vehículo.
                                    </p>
                                </div> */}
                                </div>
                                {showWhatClaim && (
                                    <div className="mt-3">
                                        <p style={{ fontWeight: "normal", fontSize: "16px" }}>
                                            <strong>Reclamaciones: </strong>En nuestro compromiso con la transparencia,
                                            proporcionamos detalles sobre las reclamaciones o accidentes reportados por
                                            las aseguradoras.
                                            <br />
                                            <br />
                                            <strong>
                                                ¿Qué es una reclamación de menor cuantía o pérdida parcial?:
                                            </strong>{" "}
                                            Una reclamación de menor cuantía ocurre cuando el costo de reparar o
                                            reemplazar partes del vehículo no excede el 75% del valor asegurado.
                                            <br />
                                            <br />
                                            <strong>¿Qué es una pérdida total?:</strong> Una pérdida total se produce
                                            cuando las reparaciones de los daños de un vehículo superan el 75% de su
                                            valor asegurable.
                                            <br />
                                            <br />
                                            <strong>¿Qué es un auto recuperado?:</strong> Un auto recuperado es aquel
                                            que previamente estaba asegurado, fue robado y el propietario recibió una
                                            indemnización por parte de la aseguradora. Sin embargo, posteriormente el
                                            vehículo fue recuperado por la aseguradora, lo que resulta en un reporte de
                                            recuperación asociado al automóvil. Este evento puede afectar el valor
                                            comercial del vehículo.
                                        </p>
                                    </div>
                                )}
                            </>
                        ),
                    },
                    {
                        title: "Características",
                        content: (
                            <div className="d-flex flex-column flex-md-row">
                                <List>
                                    {characteristics.slice(0, halfCharacteristics).map((characteristic) => (
                                        <ItemList
                                            key={characteristic.title}
                                            icon={characteristic.icon}
                                            title={characteristic.title}
                                            content={characteristic.content}
                                        />
                                    ))}
                                </List>
                                <List>
                                    {characteristics.slice(halfCharacteristics).map((characteristic) => (
                                        <ItemList
                                            key={characteristic.title}
                                            icon={characteristic.icon}
                                            title={characteristic.title}
                                            content={characteristic.content}
                                        />
                                    ))}
                                </List>
                            </div>
                        ),
                    },
                    {
                        title: "Seguridad",
                        showOption: description?.find((list) => list?.list === 3) ? true : false,
                        content: (
                            <div className="d-flex flex-column flex-md-row">
                                <List>
                                    {description?.find((item) => item?.item === 9)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/13.png"}
                                            title={"Airbags"}
                                            content={description?.find((item) => item?.item === 9)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 10)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/14.png"}
                                            title={"Frenos ABS"}
                                            content={description?.find((item) => item?.item === 10)?.content}
                                        />
                                    )}
                                </List>
                                <List>
                                    {description?.find((item) => item?.item === 11)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/15.png"}
                                            title={"Calificación seguridad"}
                                            content={description?.find((item) => item?.item === 11)?.content}
                                        />
                                    )}
                                    {withContent(description, SECURITY_EXTRA).map((e) => (
                                        <ItemList key={e.title} icon={e.icon} title={e.title} content={e.content} />
                                    ))}
                                </List>
                            </div>
                        ),
                    },
                    {
                        title: "Accesorios y  equipamiento",
                        showOption: description?.find((list) => list?.list === 4) ? true : false,
                        content: (
                            <div className="d-flex flex-column flex-md-row">
                                <List>
                                    {description?.find((item) => item?.item === 12)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/16.png"}
                                            title={"Sillas"}
                                            content={description?.find((item) => item?.item === 12)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 13)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/5.png"}
                                            title={"Tipo de radio"}
                                            content={description?.find((item) => item?.item === 13)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 14)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/17.png"}
                                            title={"Entretenimiento"}
                                            content={description?.find((item) => item?.item === 14)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 15)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/18.png"}
                                            title={"Sunroof"}
                                            content={description?.find((item) => item?.item === 15)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 16)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/19.png"}
                                            title={"Rines de lujo"}
                                            content={description?.find((item) => item?.item === 16)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 17)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/20.png"}
                                            title={"Sensores de reversa"}
                                            content={description?.find((item) => item?.item === 17)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 18)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/21.png"}
                                            title={"Cámara trasera"}
                                            content={description?.find((item) => item?.item === 18)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 19)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/22.png"}
                                            title={"Cámara 360°"}
                                            content={description?.find((item) => item?.item === 19)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 20)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/23.png"}
                                            title={"Alarma"}
                                            content={description?.find((item) => item?.item === 20)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 21)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/24.png"}
                                            title={"Asistente anti colisión"}
                                            content={description?.find((item) => item?.item === 21)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 22)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/25.png"}
                                            title={"Exploradoras"}
                                            content={description?.find((item) => item?.item === 22)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 23)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/26.png"}
                                            title={"Bluetooth"}
                                            content={description?.find((item) => item?.item === 23)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 24)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/27.png"}
                                            title={"USB"}
                                            content={description?.find((item) => item?.item === 22)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 25)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/28.png"}
                                            title={"Sensor de lluvia"}
                                            content={description?.find((item) => item?.item === 23)?.content}
                                        />
                                    )}
                                </List>
                                <List>
                                    {description?.find((item) => item?.item === 26)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/29.png"}
                                            title={"Sensor de luz"}
                                            content={description?.find((item) => item?.item === 24)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 27)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/5.png"}
                                            title={"Vidrios eléctricos"}
                                            content={description?.find((item) => item?.item === 27)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 28)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/31.png"}
                                            title={"Espejos eléctricos"}
                                            content={description?.find((item) => item?.item === 28)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 29)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/32.png"}
                                            title={"Sillas eléctricas"}
                                            content={description?.find((item) => item?.item === 29)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 30)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/33.png"}
                                            title={"Llanta de repuesto"}
                                            content={description?.find((item) => item?.item === 30)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 31)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/34.png"}
                                            title={"Apertura automática de baúl"}
                                            content={description?.find((item) => item?.item === 31)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 32)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/35.png"}
                                            title={"Calefacción en las sillas"}
                                            content={description?.find((item) => item?.item === 32)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 33)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/36.png"}
                                            title={"Timón ajustable"}
                                            content={description?.find((item) => item?.item === 33)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 34)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/37.png"}
                                            title={"Pedales ajustables"}
                                            content={description?.find((item) => item?.item === 34)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 35)?.content && ( // aire acondicionado
                                        <ItemList
                                            icon={"/assets/icons/featureList/air.png"}
                                            title={"Aire acondicionado"}
                                            content={description?.find((item) => item?.item === 35)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 36)?.content && ( // tipo de dirección
                                        <ItemList
                                            icon={"/assets/icons/featureList/direccion.png"}
                                            title={"Tipo de dirección"}
                                            content={description?.find((item) => item?.item === 36)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 37)?.content && (
                                        <ItemList
                                            icon={"/assets/icons/featureList/37.png"}
                                            title={"Comandos en el timón"}
                                            content={description?.find((item) => item?.item === 37)?.content}
                                        />
                                    )}
                                    {description?.find((item) => item?.item === 38)?.content && ( // kit de carretera
                                        <ItemList
                                            icon={"/assets/icons/featureList/kit.png"}
                                            title={"Kit de carretera"}
                                            content={description?.find((item) => item?.item === 38)?.content}
                                        />
                                    )}
                                    {withContent(description, ACCESSORIES_EXTRA).map((e) => (
                                        <ItemList key={e.title} icon={e.icon} title={e.title} content={e.content} />
                                    ))}
                                </List>
                            </div>
                        ),
                    },
                    {
                        title: "Comentarios adicionales",
                        showOption: description?.find((list) => list?.list === 5) ? true : false,
                        content: description?.find((item) => item?.list === 5)?.content,
                    },

                    {
                        title: (
                            <>
                                <div
                                    className="custom-tooltip-container"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 10,
                                        position: "relative",
                                    }}
                                >
                                    <img
                                        src="/assets/logos/logo-chatgpt.png"
                                        style={{ width: 40, height: 40 }}
                                        alt="Descripción GPT"
                                    />
                                    <h5>Descripción GPT</h5>

                                    <div className="position-relative">
                                        <img
                                            src="/assets/icons/info.svg"
                                            alt="Descripción GPT"
                                            title="Descripción GPT"
                                            className="img-fluid img_icon me-2 custom-tooltip-trigger"
                                        />
                                        <span
                                            className="warranty_tool_tip_detail position-absolute "
                                            id="custom-tooltip"
                                        >
                                            Esta descripción ha sido generada por inteligencia artificial y puede
                                            contener errores.
                                        </span>
                                    </div>
                                </div>
                            </>
                        ),
                        showOption: car?.description_ai ? true : false,
                        content: (
                            <>
                                <p>
                                    <ReactMarkdown>
                                        {car.description_ai
                                            ?.replace("condición de nuevo", "condición de usado")
                                            ?.replace("condición nueva", "condición usada")
                                            ?.replace("estado nuevo", "condición usado")
                                            ?.replace("**condición de nuevo**", "**condición de usado**")
                                            ?.replace(
                                                "lo que significa que está listo para ofrecer una experiencia de conducción excepcional desde el primer momento.",
                                                "",
                                            ) || ""}
                                    </ReactMarkdown>
                                </p>
                            </>
                        ),
                    },
                ]}
            />
        </div>
    );
};
